export default {"src":"/_next/static/media/FacebookInverted.ee7075e4.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};